import { useQuery } from "@tanstack/react-query";
import IQACMission from "../../components/CenterOfExcellence/IQACMission";
// import PublicationCarousel from "../../components/CenterOfExcellence/PublicationCarousel";
import ZUMSAdmin from "../../components/CenterOfExcellence/ZUICAdmin";
import AnimatedQuote from "../../components/ui/Card/AnimatedQuoteCard";
// import FeaturedEvents from "../../components/ui/FeaturedEvents";
import ImageHeading from "../../components/ui/ImageHeading";
import ResearchCTA from "../../components/ui/ResearchCTA";
import useAxiosPublic from "../../hooks/useAxiosPublic";
import LoadingPage from "../../components/Layout/LoadingPage";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
// const whatWeOfferData = [
//   {
//     id: 1,
//     title: "Professional Development Courses",
//     description:
//       "Specialized skill-based workshops and certification programs in emerging fields like Artificial Intelligence, Climate Change, and Entrepreneurship.",
//   },
//   {
//     id: 2,
//     title: "Personal Enrichment Programs",
//     description:
//       "Creative arts, language classes, and personal wellness programs offering opportunities for exploring new hobbies and interests.",
//   },
//   {
//     id: 3,
//     title: "Online Learning Opportunities",
//     description:
//       "Self-paced and instructor-led courses accessible anytime, anywhere, with partnerships for internationally recognized certifications.",
//   },
//   {
//     id: 4,
//     title: "Customized Corporate Training",
//     description:
//       "Tailored solutions for businesses and organizations to upskill their workforce and address industry challenges.",
//   },
//   {
//     id: 5,
//     title: "Community Engagement Initiatives",
//     description:
//       "Outreach programs to promote education in underserved communities, including free workshops and seminars for local learners.",
//   },
// ];

const CLLL = () => {
  const axiosPublic = useAxiosPublic();

  const {
    data: cllApiData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["cllApi"],
    queryFn: async () => {
      const res = await axiosPublic.get("/centers/clll");
      return res?.data?.data;
    },
  });

  if (isLoading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <div className="text-center py-20 text-red-500">Error loading data</div>
    );
  }
  console.log(cllApiData, "cll data");
  return (
    <div>
      <ImageHeading
        heading={cllApiData?.hero?.title}
        imageUrl={cllApiData?.hero?.media_url}
      />
      <div className="container px-4 mx-auto md:px-8 lg:px-0 ">
        {/* quote */}
        <div className="">
          <AnimatedQuote
            author={cllApiData?.clll?.quotes?.author}
            quote={cllApiData?.clll?.quotes?.description}
          />
        </div>
        <div className="gap-8 my-12 ">
          <div>
            <div>
              <h3 className="text-2xl font-bold text-black lg:text-4xl font-domine">
                {cllApiData?.clll?.title}
              </h3>
              <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                {cllApiData?.clll?.description}
              </ReactMarkdown>
            </div>

            <IQACMission
              title={cllApiData?.clll?.what_we_offer?.title}
              details={cllApiData?.clll?.what_we_offer?.description}
              data={cllApiData?.clll?.what_we_offer?.points}
            />

            <div className="py-12 space-y-20">
              {/* <PublicationCarousel title={"Publication & Report"} /> */}
              <ZUMSAdmin title={"Leader"} data={cllApiData?.clll?.team_members} />
              <ZUMSAdmin title={"Member"} data={cllApiData?.clll?.team_members} />
              {/* <FeaturedEvents /> */}
              <ResearchCTA
                title={cllApiData?.clll?.contact?.title}
                mail={cllApiData?.clll?.contact?.email}
                number={cllApiData?.clll?.contact?.phone}
                description={cllApiData?.clll?.contact?.description}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CLLL;
